import React from "react";
import BaseSpread, { CardPosition } from "./BaseSpread";

// Position data for Celtic Cross spread (10 cards)
// Each position contains: left, top, width, height (all in percentages)
export const celticCrossPositions: CardPosition[] = [
    { left: 30, top: 30, width: 12, height: 20 },      // 0: First element at 0% left
    { left: 30, top: 30, width: 12, height: 20 },      // 1: Challenge (crossing card, smaller)
    { left: 30, top: 0, width: 12, height: 20 },     // 2: Focus (above center) - increased size, moved up
    { left: 0, top: 30, width: 12, height: 20 },     // 3: Recent Past (left) - increased size, moved left
    { left: 30, top: 60, width: 12, height: 20 },     // 4: Possible Outcome (below center) - increased size, moved down
    { left: 54, top: 30, width: 12, height: 20 },     // 5: Near Future (right) - increased size, moved right
    { left: 79, top: 90, width: 12, height: 20 },     // 6: Your Approach (bottom right column) - increased size
    { left: 79, top: 60, width: 12, height: 20 },     // 7: External Influences (middle right column) - increased size
    { left: 79, top: 30, width: 12, height: 20 },     // 8: Hopes & Fears (top right column) - increased size
    { left: 79, top: 0, width: 12, height: 20 }       // 9: Final Outcome (last element at right edge: 100% - 12% = 88%)
];

const CelticCross = ({ size, cardWidth, displaySpread, getCard }: { size?: number, cardWidth: number, displaySpread: boolean, getCard: (index: number) => React.ReactNode }) => {
    return (
        <BaseSpread
            positions={celticCrossPositions}
            size={size}
            cardWidth={cardWidth}
            displaySpread={displaySpread}
            getCard={getCard}
            rotatedCards={[1]} // Challenge card (index 1) should be rotated
            name="celtic-cross"
        />
    );
};

export default CelticCross;